module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-1.2e6e1e9e.jpg";